<template>
  <div :id="id" ref="main">
    <div class="wrapper">
      <slot name="default" />
    </div>
  </div>
</template>

<script>
import PullToRefresh from 'pulltorefreshjs';

const PROPS_RELATIONSHIP = {
  pullToRefreshMessage: 'instructionsPullToRefresh',
  releaseToRefreshMessage: 'instructionsReleaseToRefresh',
  refreshingMessage: 'instructionsRefreshing',
  shouldPullToRefresh: 'shouldPullToRefresh',
  refreshTimeout: 'refreshTimeout',
};

export default {
  props: {
    pullToRefreshMessage: {
      type: String,
      default: () => 'Desliza hacia abajo para actualizar',
    },
    releaseToRefreshMessage: {
      type: String,
      default: () => 'Suelta para actualizar',
    },
    refreshingMessage: {
      type: String,
      default: () => 'Actualizando',
    },
    refreshTimeout: {
      type: Number,
      default: () => 0,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      prtInstance: null,
    };
  },
  methods: {
    updatePTRInstance() {
      Object.entries(PROPS_RELATIONSHIP)
        .filter((entry) => this[entry[0]] !== this.prtInstance[entry[1]])
        .forEach((entry) => {
          this.prtInstance[entry[1]] = this[entry[0]];
        });

      /* this.prtInstance.update({
        instructionsPullToRefresh: options.pullToRefreshMessage,
        instructionsReleaseToRefresh: options.releaseToRefreshMessage,
        instructionsRefreshing: options.refreshingMessage,
      }); */
    },
  },
  computed: {
    id() {
      // eslint-disable-next-line no-underscore-dangle
      return this._uid;
    },
    shouldPullToRefresh() {
      return () => !this.disabled && !this.prtInstance.mainElement.scrollTop;
    },
  },
  updated() {
    this.updatePTRInstance();
  },
  mounted() {
    this.prtInstance = PullToRefresh.init({
      mainElement: this.$refs.main,
      onRefresh: () => {
        this.$emit('refresh');
        return Promise.resolve();
      },
    });

    this.updatePTRInstance();
  },
  beforeUnmount() {
    this.prtInstance.destroy();
  },
};
</script>
